import React, { useEffect, useState } from 'react';
import WishListModal from '../Modal/WishListModal';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import QuickViewModal from '../Modal/QuickViewModal';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
const WishList = () => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [sortBy, setSortBy] = useState('featured');
  const [showQuickView, setShowQuickView] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const [wishlist, setWishlist] = useState(products.map(p => p.id));
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const handleQuickAdd = (productId) => {
    const product = products.find(p => p.id === productId);
    if (product) {
      setSelectedProduct(product);
      setShowQuickView(true);
    }
  };


  const ProductSkeleton = () => (
    <div className="col">
      <div className="card h-100 product-card">
        <div className="skeleton skeleton-img"></div>
        <div className="card-body">
          <div className="skeleton skeleton-text w-75 mb-2"></div>
          <div className="skeleton skeleton-text w-50"></div>
        </div>
      </div>
    </div>
  );

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await axios.get('https://vantara.datacubeglobal.com/api/wishlist');
  //       const data = res.data;
  //       if (Array.isArray(data)) {
  //         const mappedProducts = data.map((p, index) => ({
  //           id: index + 1,
  //           product_id: p.product_id,
  //           name: p.product_name,
  //           price: parseFloat(p.special_price) || parseFloat(p.mrp),
  //           originalPrice: parseFloat(p.mrp),
  //           rating: 0,
  //           reviews: 0,
  //           image: p.primary_image ? `https://vantara.datacubeglobal.com/vantara/storage/app/public/${p.primary_image}` : '',
  //           category: p.category || 'Others',
  //           isNew: false,
  //           isSale: parseFloat(p.special_price) < parseFloat(p.mrp)
  //         }));
  //         setProducts(mappedProducts);
  //         setFilteredProducts(mappedProducts);
  //         setWishlist(mappedProducts.map(p => p.id));
  //       } else {
  //         setProducts([]);
  //         setFilteredProducts([]);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching products:', error);
  //     } finally {
  //       setLoading(false); // stop loading
  //     }
  //   };

  //   fetchProducts();
  // }, []);
  useEffect(() => {
    const fetchProducts = async () => {
      const token = getAuthToken();

      if (!token) {
        Swal.fire({
          toast: true,
          icon: "info",
          title: "Please login to view your wishlist",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        setProducts([]);
        setFilteredProducts([]);
        return;
      }

      try {
        setLoading(true);
        const res = await axios.get('https://vantara.datacubeglobal.com/api/wishlist', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        // ✅ Correctly extract the array from res.data.data
        const productArray = res.data.data;

        if (Array.isArray(productArray)) {
          const mappedProducts = productArray.map((p, index) => ({
            id: index + 1,
            product_id: p.product_id,
            name: p.product_name,
            price: parseFloat(p.special_price) || parseFloat(p.mrp),
            originalPrice: parseFloat(p.mrp),
            rating: 0,
            reviews: 0,
            image: p.primary_image ? `https:\/\/vantara.datacubeglobal.com\/storage/${p.primary_image}` : '',
            category: p.category || 'Others',
            isNew: false,
            isSale: parseFloat(p.special_price) < parseFloat(p.mrp)
          }));
          setProducts(mappedProducts);
          setFilteredProducts(mappedProducts);
          setWishlist(mappedProducts.map(p => p.id));
        } else {
          setProducts([]);
          setFilteredProducts([]);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        Swal.fire({
          toast: true,
          icon: "error",
          title: "Failed to fetch wishlist",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);




  useEffect(() => {
    if (showQuickView) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [showQuickView]);


  const handleClose = () => {
    setShowQuickView(false);
  };

  const handleSortChange = (e) => {
    const sortValue = e.target.value;
    setSortBy(sortValue);

    let sortedProducts = [...filteredProducts];
    switch (sortValue) {
      case 'priceLowHigh':
        sortedProducts.sort((a, b) => a.price - b.price);
        break;
      case 'priceHighLow':
        sortedProducts.sort((a, b) => b.price - a.price);
        break;
      case 'rating':
        sortedProducts.sort((a, b) => b.rating - a.rating);
        break;
      default:
        sortedProducts = products;
    }
    setFilteredProducts(sortedProducts);
  };



  const toggleWishlist = async (product) => {
    const token = getAuthToken();


    // if (!token) {
    //   setShowLoginModal(true);
    //   return;
    // }
    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/wishlist",
        { product_id: product.product_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }

      );

      if (res.data.status === true) {
        if (res.data.message === "Removed") {
          // ✅ Product removed from wishlist
          setWishlist(wishlist.filter((id) => id !== product.id));

          Swal.fire({
            toast: true,
            icon: "info",
            title: "Removed from Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          // ✅ Product added to wishlist
          setWishlist([...wishlist, product.id]);
          setShowWishlist(true);

          Swal.fire({
            toast: true,
            icon: "success",
            title: "Added to Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
      } else {
        // ❌ API returned false status
        Swal.fire({
          toast: true,
          icon: "info",
          title: res.data.message || "Already in Wishlist",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);

      if (error.response && error.response.status === 409) {
        Swal.fire({
          toast: true,
          icon: "info",
          title: error.response.data?.message || "Already in Wishlist",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          toast: true,
          icon: "error",
          title: "Something went wrong!",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    }
  };
  const token = getAuthToken();
  if (!token) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center py-5" style={{ minHeight: "60vh" }}>
        <h3
          className="text-center mb-3"
          style={{ color: '#1C3F1D' }}
        >
          You need to login to view your wishlist
        </h3>

        <p className="text-muted text-center mb-4">
          Sign in to access your saved products and personalized experience.
        </p>
        <Link
          to="/login"
          className="btn btn-lg rounded-pill px-4 py-2 shadow-sm"
          style={{ backgroundColor: '#7C0046', color: '#fff', border: 'none' }}
        >
          Login
        </Link>

      </div>
    );
  }
  return (
    <div className="container-fluid py-4">

      {/* Wishlist Modal */}
      <WishListModal
        show={showWishlist}
        onHide={() => setShowWishlist(false)}
        wishlistItems={products.filter(p => wishlist.includes(p.id))}
        onRemove={(id) => setWishlist(prev => prev.filter(pid => pid !== id))}
      />

   
      <div className="row mb-4">

      </div>

    
      <div className="row row-cols-2 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 g-3">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => <ProductSkeleton key={i} />) 
          : filteredProducts.map(product => (
            <div key={product.id} className="col">
              <div className="card h-100 product-card">
                <div className="position-relative overflow-hidden">
                  <img
                    src={product.image}
                    className="card-img-top"
                    alt={product.name}
                    onClick={() => navigate(`/productDetails/${product.product_id}`)}

                    style={{ height: '250px', objectFit: 'cover' }}
                  />

             
                  <div className="position-absolute top-0 start-0 m-2">
                    {product.isNew && <span className="badge bg-primary">New</span>}
                    {product.isSale && <span className="badge bg-danger ms-1">Sale</span>}
                  </div>

                  
                  <button
                    className="btn btn-light rounded-circle shadow-sm position-absolute top-0 end-0 m-2"
                    style={{ width: "40px", height: "40px" }}
                    onClick={() => toggleWishlist(product)}
                  >
                    {wishlist.includes(product.id)
                      ? <FaHeart className="text-danger" />
                      : <FaRegHeart className="text-danger" />}
                  </button>


                  <div className="product-actions position-absolute bottom-0 start-0 end-0 p-2 d-flex justify-content-center">
                    <button
                      className="btn  add-to-cart-btn rounded-pill px-3"
                      style={{ backgroundColor: "#7c0046", color: "#fff" }}
                      onClick={() => handleQuickAdd(product.id)}
                    >
                      ADD TO CART
                    </button>
                    <button
                      className="btn btn-light rounded-circle shadow-sm ms-2"
                      style={{ width: "40px", height: "40px" }}
                      onClick={() => navigate(`/productDetails/${product.product_id}`)}

                    >
                      <i className="bi bi-eye"></i>
                    </button>
                  </div>
                </div>

                {/* Card Body */}
                <div className="card-body">
                  <h6 className="card-title mb-1">{product.name}</h6>
                  <div className="d-flex align-items-center mt-1">
                    <span className="h6 mb-0 text-danger fw-bold">
                      ₹{product.price.toFixed(2)}</span>
                    {product.originalPrice > product.price && (
                      <span className="text-muted text-decoration-line-through ms-2 small">
                        {product.originalPrice.toFixed(2)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Quick View Modal */}
      <QuickViewModal
        show={showQuickView}
        onHide={handleClose}
        product={selectedProduct}
      />

      {/* Card Hover Styles */}
      <style jsx>{`
        .product-card {
          border: none;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .product-card:hover {
          transform: translateY(-5px);
       
        }
        .product-actions {
          transform: translateY(100%);
          transition: transform 0.3s ease;
       
        }
        .product-card:hover .product-actions {
          transform: translateY(0);
        }
        .add-to-cart-btn {
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          padding: 0.5rem 1.2rem;
          text-transform: uppercase;
        }
            .skeleton {
  background: linear-gradient(90deg, #eee, #f5f5f5, #eee);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 8px;
}

.skeleton-img {
  height: 300px;
  width: 100%;
}

.skeleton-text {
  height: 16px;
  margin-top: 8px;
}

@keyframes skeleton-loading {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
      `}</style>
    </div>
  );
};

export default WishList;



// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import WishListModal from '../Modal/WishListModal';
// import { FaHeart, FaRegHeart } from 'react-icons/fa';
// import QuickViewModal from '../Modal/QuickViewModal';
// import { useNavigate } from 'react-router-dom';

// const WishList = () => {
//   const navigate = useNavigate();

//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [wishlist, setWishlist] = useState([]); // will hold wishlist product_ids
//   const [sortBy, setSortBy] = useState('featured');
//   const [showQuickView, setShowQuickView] = useState(false);
//   const [showWishlist, setShowWishlist] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);

//   // Fetch products & wishlist
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // 1. Fetch products
//         const resProducts = await axios.get(
//           "https://vantara.datacubeglobal.com/api/products"
//         );

//         let mappedProducts = [];
//         if (resProducts.data.status === "success") {
//           mappedProducts = resProducts.data.data.map((p) => ({
//             id: p.product_id, // use API product_id directly
//             product_id: p.product_id,
//             name: p.product_name,
//             price: parseFloat(p.special_price) || parseFloat(p.mrp),
//             originalPrice: parseFloat(p.mrp),
//             rating: 0,
//             reviews: 0,
//            image: p.primary_image ? `https://vantara.datacubeglobal.com/vantara/storage/app/public/${p.primary_image}` : '',
//             category: p.category || "Others",
//             isNew: false,
//             isSale: parseFloat(p.special_price) < parseFloat(p.mrp),
//           }));
//         }

//         setProducts(mappedProducts);
//         setFilteredProducts(mappedProducts);

//         // 2. Fetch wishlist
//         const resWishlist = await axios.get(
//           "https://vantara.datacubeglobal.com/api/wishlist/1"
//         );

//         const wishlistProductIds = resWishlist.data.map((item) => item.product_id);

//         // 3. Filter only wishlist products
//         const matchedProducts = mappedProducts.filter((p) =>
//           wishlistProductIds.includes(p.product_id)
//         );

//         setWishlist(wishlistProductIds); // store product ids
//         setFilteredProducts(matchedProducts); // show only wishlist products
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleQuickAdd = (productId) => {
//     const product = products.find((p) => p.product_id === productId);
//     if (product) {
//       setSelectedProduct(product);
//       setShowQuickView(true);
//     }
//   };

//   const handleClose = () => {
//     setShowQuickView(false);
//   };

//   return (
//     <div className="container-fluid py-4">
//       {/* Wishlist Modal */}
//       <WishListModal
//         show={showWishlist}
//         onHide={() => setShowWishlist(false)}
//         wishlistItems={products.filter((p) => wishlist.includes(p.product_id))}
//         onRemove={(id) =>
//           setWishlist((prev) => prev.filter((pid) => pid !== id))
//         }
//       />

//       {/* Product Grid */}
//       <div className="row row-cols-2 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 g-3">
//         {filteredProducts.map((product) => (
//           <div key={product.product_id} className="col">
//             <div className="card h-100 product-card">
//               <div className="position-relative overflow-hidden">
//                 <img
//                   src={product.image}
//                   className="card-img-top"
//                   alt={product.name}
//                   style={{ height: "250px", objectFit: "cover" }}
//                 />

//                 {/* Wishlist Icon */}
//                 <button
//                   className="btn btn-light rounded-circle shadow-sm position-absolute top-0 end-0 m-2"
//                   style={{ width: "40px", height: "40px" }}
//                   onClick={() => setShowWishlist(true)}
//                 >
//                   {wishlist.includes(product.product_id) ? (
//                     <FaHeart className="text-danger" />
//                   ) : (
//                     <FaRegHeart className="text-danger" />
//                   )}
//                 </button>

//                 {/* Hover Actions */}
//                 <div className="product-actions position-absolute bottom-0 start-0 end-0 p-2 d-flex justify-content-center">
//                   <button
//                     className="btn btn-dark add-to-cart-btn rounded-pill px-3"
//                     onClick={() => handleQuickAdd(product.product_id)}
//                   >
//                     ADD TO CART
//                   </button>
//                   <button
//                     className="btn btn-light rounded-circle shadow-sm ms-2"
//                     style={{ width: "40px", height: "40px" }}
//                     onClick={() =>
//                       navigate(`/productDetails/${product.product_id}`)
//                     }
//                   >
//                     <i className="bi bi-eye"></i>
//                   </button>
//                 </div>
//               </div>

//               <div className="card-body">
//                 <h6 className="card-title mb-1">{product.name}</h6>
//                 <div className="d-flex align-items-center mt-1">
//                   <span className="h6 mb-0 text-danger">
//                     ${product.price.toFixed(2)}
//                   </span>
//                   {product.originalPrice > product.price && (
//                     <span className="text-muted text-decoration-line-through ms-2 small">
//                       ${product.originalPrice.toFixed(2)}
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Quick View Modal */}
//       <QuickViewModal
//         show={showQuickView}
//         onHide={handleClose}
//         product={selectedProduct}
//       />
//     </div>
//   );
// };

// export default WishList;
